import app from 'flarum/common/app';

export default function (url: string): string {
    // We are not going to proxy URLs to ourselves as the proxy might not be able to handle them and it's not a privacy issue
    const uri = new URL(url);

    if (app.forum.attribute('richEmbedsImageProxy') && uri.host !== window.location.host) {
        return app.forum.attribute('apiUrl') + '/kilowhat-rich-embeds/proxy?' + m.buildQueryString({
            url,
        });
    }

    return url;
}
